export function moneyCents(value: string): bigint | null {
  if (!/^\d{1,10}(\.\d{1,2})?$/.test(value)) return null;
  const [whole = '0', fraction = ''] = value.split('.');
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
  return cents <= 999999999999n ? cents : null;
}

export function sameMoneyAmount(left: string, right: string): boolean {
  const value = moneyCents(left);
  return value !== null && value === moneyCents(right);
}
